import { Text } from "@clipboard-health/ui-components";
import { Stack } from "@mui/material";

export function NewsFeedReachedEndState() {
  return (
    <Stack justifyContent="center" alignItems="center">
      <Text color={(theme) => theme.palette.text.tertiary}>
        You reached the end of your news feed
      </Text>
    </Stack>
  );
}
